// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__X2l2m","subTitle":"index_subTitle__ntGue","cancel":"index_cancel__OaKui"};